import { configureStore } from '@reduxjs/toolkit';
import reducers from './reducers';
import { coachmarksSlice } from './api/coachmarksSlice';

const store = configureStore({
    reducer: reducers,
    middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(coachmarksSlice.middleware),
});

export type LCPState = ReturnType<typeof store.getState>;
export type LCPDispatch = typeof store.dispatch;

export default store;
